import L from "leaflet";
import { Marker } from "react-leaflet";
import { Length } from "../../../services/RuteplanAPI";
import lengdeIconResource from "../../../assets/lengde.svg";
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const lengdeIcon = L.icon({
    iconUrl: lengdeIconResource,
    iconRetinaUrl: lengdeIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
});

export interface ILengdeMarkersProps {
    lengdebegrensninger: Array<Length>;
}

export default function LengdeMarkers (props: ILengdeMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();
    const { lengdebegrensninger } = props;

    return (
        <>
            {lengdebegrensninger && lengdebegrensninger.map((lengdebegrensing: Length, index: number) => {
                return (
                    <Marker key={lengdebegrensing.maxLength + index}
                    position={[lengdebegrensing.location!.y, lengdebegrensing.location!.x]}
                    icon={lengdeIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(lengdebegrensing);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}
